module.exports = __webpack_public_path__ + "img/p5.366a5033.gif";